export default __webpack_public_path__ + "static/media/Kale-Closeup-100px.21c684a4.jpg";